import axios from "axios";
import { useEffect, useState } from "react";
import CreateUserPage from "../create/CreateUserPage";

export default function AddUsersModal({ listId,title,add, onClose, addUser}) {

  const API_BASE = "https://api.ilogically.com/api";
  const APP_TOKEN = "87adfacc2dffc65ae172d59a9f0badda";

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔎 Filters
  const [search, setSearch] = useState("");
  const [role, setRole] = useState("student");
  const [status, setAccountStatus] = useState("active");
  const [registeredFrom, setRegisteredFrom] = useState("");
  const [registeredTo, setRegisteredTo] = useState("");

  const [sortBy, setSortBy] = useState("userRegisteredDate");
  const [sortOrder, setSortOrder] = useState("DESC");

  const [limit] = useState(10);
  const [offset, setOffset] = useState(0);

  const [addedUsers, setAddedUsers] = useState([]);

  const fetchUsers = async () => {

    try {

      setLoading(true);

      const res = await axios.get(
        `${API_BASE}/users`,
        {
          params: {
            role,
            search,
            status,
            registeredFrom,
            registeredTo,
            sortBy,
            sortOrder,
            limit,
            offset,
            appToken: APP_TOKEN
          }
        }
      );

      setUsers(res.data);

    } catch (err) {
      console.error("Fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [role, status,registeredFrom,registeredTo,search, offset, sortBy, sortOrder]);

  const applyFilters = () => {
    setOffset(0);
    fetchUsers();
  };

 

  const nextPage = () => {
    setOffset(prev => prev + limit);
  };

  const prevPage = () => {
    setOffset(prev => Math.max(prev - limit, 0));
  };

  return (
    <div style={{ border: "1px solid #ccc", padding: 20, width: 800 }}>
     
      <CreateUserPage listId={listId} />
      <h3>{title}</h3>

      {/* 🔎 Filters Section */}
      <div style={{ marginBottom: 20, display: "grid", gap: 10 }}>

        <input
          placeholder="Search name or email"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <div style={{ display: "flex", gap: 10 }}>

          <select value={role} onChange={(e) => setRole(e.target.value)}>
            <option value="">All Roles</option>
            <option value="student">Student</option>
            <option value="teacher">Teacher</option>
            <option value="staff">Staff</option>
            <option value="batchbuddy">BatchBuddy</option>
          </select>

          <select
            value={status}
            onChange={(e) => setAccountStatus(e.target.value)}
          >
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="blocked">Blocked</option>
          </select>

          <input
            type="date"
            value={registeredFrom}
            onChange={(e) => setRegisteredFrom(e.target.value)}
          />

          <input
            type="date"
            value={registeredTo}
            onChange={(e) => setRegisteredTo(e.target.value)}
          />

        </div>

        <div style={{ display: "flex", gap: 10 }}>

          <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
            <option value="userRegisteredDate">Registered Date</option>
            <option value="firstName">First Name</option>
            <option value="lastName">Last Name</option>
            <option value="userEmail">Email</option>
            <option value="role">Role</option>
          </select>

          <select value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
            <option value="DESC">DESC</option>
            <option value="ASC">ASC</option>
          </select>

          

        </div>

      </div>

      {/* 🔄 Loading */}
      {loading && <p>Loading...</p>}

      {!loading && users.length === 0 && (
        <p>No users found.</p>
      )}

      {!loading && users.map((u) => (
        <div
          key={u.ID}
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: 8,
            padding: 6,
            borderBottom: "1px solid #eee"
          }}
        >
          <div>
            <strong>{u.firstName} {u.lastName}</strong>
            <div style={{ fontSize: 12 }}>{u.userEmail}</div>
            <div style={{ fontSize: 11 }}>
              {u.role} | {u.accountStatus}
            </div>
          </div>
{add? <button
            disabled={addedUsers.includes(u.ID)}
            onClick={() => {addUser(u);}}
          >
            {addedUsers.includes(u.ID) ? "Added" : "Add"}
          </button>:""}
         
        </div>
      ))}

      {/* 📄 Pagination */}
      <div style={{ marginTop: 15 }}>
        <button onClick={prevPage} disabled={offset === 0}>
          Previous
        </button>

        <button onClick={nextPage} style={{ marginLeft: 10 }}>
          Next
        </button>
      </div>

      <div style={{ marginTop: 20 }}>
        <button onClick={onClose}>Close</button>
      </div>
    </div>
  );
}